<div class="sum-items-container" (click)="closeDropDowns()">

    <div class="ratio-selection">
        <div class="numerator-selection">
            <span class="text"> {{ 'aumico_notes_super_table_ratio_choose_rows_for' | i18next }}</span>
            <div class="item-selection-flex-container">
                <div class="custom-dropdown" data-testid="calculation-items-dropdown" (click)="toggleNumeratorDropdown($event)">
                    <span *ngIf="selectedNumeratorItems.length === 0">{{
                        'aumico_notes_super_table_ratio_numerator' | i18next
                    }}</span>
                    <span *ngIf="selectedNumeratorItems.length !== 0"
                        >{{ selectedNumeratorItems.length }}
                        {{ 'aumico_notes_super_table_calculation_item_selected' | i18next }}</span
                    >
                    <span class="ham-icon">
                        <i class="chevron-down-icon"></i>
                    </span>
                </div>
                <div *ngIf="numeratorDropdownOpen" class="dropdown-options" stopPropagation>
                    <div
                        *ngFor="let item of rowSelectionOptions"
                        class="dropdown-item"
                        (click)="onSelectNumeratorItem(item)"
                    >
                        <span class="selection-col caption">
                            <!-- Selection Checkbox -->
                            <span
                                hamCheckbox
                                [checked]="isNumeratorSelected(item)"
                                (change)="onSelectNumeratorItem(item)"
                            ></span>

                            <span
                                class="text"
                                data-testid="calculation-item-label"
                                [hamTooltip]="item.caption"
                                [tooltipOnlyWhenTruncated]="true"
                                [tooltipAboveModals]="true"
                            >
                                {{ item.caption }}
                            </span>
                        </span>
                        <span class="selection-col current-year">{{ item.currentValue | finNumber }}</span>
                        <span class="selection-col previous-year">{{ item.previousValue | finNumber }}</span>
                    </div>
                </div>
                <div class="chips-container">
                    <div *ngIf="!numeratorDropdownOpen && selectedNumeratorItems.length !== 0" class="selected-items">
                        <span *ngFor="let item of selectedNumeratorItems" class="chip">
                            {{ item.caption }} <span class="remove-icon" (click)="removeNumeratorItem(item)">×</span>
                        </span>
                    </div>
                </div>
                <span class="division-line"></span>
            </div>
        </div>

        <div class="numerator-selection">
            <span class="text"> {{ 'aumico_notes_super_table_ratio_choose_row_for' | i18next }}</span>
            <div class="item-selection-flex-container">
                <div class="custom-dropdown" (click)="toggleDenomenatorDropdown($event)">
                    <span *ngIf="selectedDenomenatorItem == null">{{
                        'aumico_notes_super_table_ratio_denomenator' | i18next
                    }}</span>
                    <span *ngIf="selectedDenomenatorItem != null"
                        >1 {{ 'aumico_notes_super_table_calculation_item_selected' | i18next }}</span
                    >
                    <span class="ham-icon">
                        <i class="chevron-down-icon"></i>
                    </span>
                </div>
                <div *ngIf="denomenatorDropdownOpen" class="dropdown-options" stopPropagation>
                    <div
                        *ngFor="let item of rowSelectionOptions"
                        class="dropdown-item"
                        (click)="onSelectDenomenatorItem(item)"
                    >
                        <span class="selection-col caption">
                            <!-- Selection Checkbox -->
                            <span
                                hamCheckbox
                                [checked]="selectedDenomenatorItem?.name === item.name"
                                (change)="onSelectDenomenatorItem(item)"
                            ></span>

                            <span
                                class="text"
                                data-testid="calculation-item-label"
                                [hamTooltip]="item.caption"
                                [tooltipOnlyWhenTruncated]="true"
                                [tooltipAboveModals]="true"
                            >
                                {{ item.caption }}
                            </span>
                        </span>
                        <span class="selection-col current-year">{{ item.currentValue | finNumber }}</span>
                        <span class="selection-col previous-year">{{ item.previousValue | finNumber }}</span>
                    </div>
                </div>
                <div class="chips-container">
                    <div *ngIf="!denomenatorDropdownOpen && selectedDenomenatorItem" class="selected-items">
                        <span class="chip">
                            {{ selectedDenomenatorItem.caption }}
                            <span class="remove-icon" (click)="removeDenomenatorItem()">×</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
